export function Spinner() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="fixed top-1/2 left-1/2 z-50 flex size-[20vmin] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-[4vmin] bg-panel/95 shadow-2xl"
    >
      <div className="size-[8vmin] animate-spin rounded-full border-4 border-neutral-600 border-t-teal-400" />
    </div>
  );
}
